// src/pages/NoInternet.jsx
import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import spandanLogo from "../assets/images/logos/spandan-logo.svg";

const PRIMARY = "#5751E9";

export default function NoInternet() {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "85vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          p: 4,
          borderRadius: 4,
          background: "var(--app-surface)",
          boxShadow: "var(--app-shadow)",
          "@keyframes slideUpFade": {
            "0%": { transform: "translateY(18px)", opacity: 0 },
            "100%": { transform: "translateY(0)", opacity: 1 },
          },
          animation: "slideUpFade 420ms cubic-bezier(.2,.9,.2,1) forwards",
        }}
      >
        {/* Floating Icon */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
            "@keyframes floatY": {
              "0%": { transform: "translateY(0px)" },
              "50%": { transform: "translateY(-8px)" },
              "100%": { transform: "translateY(0px)" },
            },
            animation: "floatY 3.6s ease-in-out infinite",
          }}
        >
          <WifiOffIcon sx={{ fontSize: 80, color: PRIMARY }} />
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, fontFamily:"figtree" }}>
          No Internet Connection
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, maxWidth: "88%", mx: "auto", fontFamily:"figtree" }}
        >
          It looks like you are offline. Please check your internet connection
          and try again.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <Button
            variant="contained"
            onClick={handleRetry}
            sx={{
              backgroundColor: PRIMARY,
              "&:hover": { backgroundColor: "#453FD3" },
              textTransform: "none",
              fontWeight: 700,
              px: 3,
              fontFamily:"figtree"
            }}
          >
            Retry
          </Button>
        </Box>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 3, fontFamily:"figtree" }}
        >
          Once you're back online, this page will reload automatically.
        </Typography>
      </Box>
    </Container>
  );
}
